import store from '../store';

const authProvider = {
  login: () => Promise.resolve(),
  logout: () => {
    store.dispatch('authentication/clearTokens');
  },
  checkAuth: () =>
    store.getters['authentication/loggedIn'] === true
      ? Promise.resolve({
          data: true,
        })
      : Promise.reject(),
  checkError: () => Promise.resolve(),
  getName: () => store.getters['user/getUserName'],
  getEmail: () => store.getters['user/getUserEmail'],
  getPermissions: () => store.getters['user/getUserRoles'],
};

export default authProvider;
